// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export interface Version {
    version: string;
    branch: string;
    hash: string;
    buildAt: string;
    [K:string]: string|boolean|null;
}
export const VERSION = {
    "dirty": true,
    "raw": "9fe0a73-dirty",
    "hash": "9fe0a73",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "9fe0a73-dirty",
    "semverString": null,
    "version": "1.17.4",
    "buildAt": "2025-04-09T19:50:46.958Z",
    "branch": "HEAD"
};
/* tslint:enable */
